import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthContext from '../context/AuthContext';
import authService from '../services/authService';
import { BASE_URL } from '../services/api';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // API'ye istek at
      const response = await authService.login(email, password);
      
      // Context'teki login fonksiyonunu çağır (Token'ı kaydeder)
      login(response.token);
      
      toast.success('Giriş başarılı! Yönlendiriliyorsunuz...');
      
      if (response.user.role === 'bayi') {
        navigate('/dealer-dashboard');
      } else {
        navigate('/dashboard');
      }
      
    } catch (error) {
      // Hata mesajını göster
      const message = error.response?.data?.message || 'Giriş yapılamadı.';
      toast.error(message);
    }
  };

  return (
    <div className="container-fluid vh-100 overflow-hidden">
      <div className="row h-100">
        {/* Sol Taraf - Görsel Alanı */}
        <div className="col-md-6 d-none d-md-block p-0 position-relative bg-dark">
          <img 
            src={`${BASE_URL}/uploads/login-bg.jpg?v=${new Date().getTime()}`} 
            alt="Giriş Görseli" 
            className="w-100 h-100"
            style={{ objectFit: 'cover', opacity: 0.8 }}
            onError={(e) => { e.target.style.display = 'none'; }} // Resim yoksa gizle, arka plan rengi görünsün
          />
          <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.7))' }}></div>
          <div className="position-absolute bottom-0 start-0 p-5 text-white">
            <h2 className="fw-bold">Hoş Geldiniz</h2>
            <p className="lead">İşletmenizi güvenle ve kolayca yönetin.</p>
          </div>
        </div>

        {/* Sağ Taraf - Giriş Formu */}
        <div className="col-md-6 d-flex align-items-center justify-content-center bg-white">
          <div style={{ width: '100%', maxWidth: '400px', padding: '20px' }}>
            <div className="text-center mb-4">
              <img 
                src={`${BASE_URL}/uploads/login-logo.png?v=${new Date().getTime()}`} 
                alt="Logo" 
                className="mb-3"
                style={{ maxHeight: '80px', objectFit: 'contain' }}
                onError={(e) => { 
                  // Eğer özel giriş logosu yoksa, varsayılan logoyu dene
                  e.target.src = `${BASE_URL}/uploads/logo.png?v=${new Date().getTime()}`;
                  e.target.onerror = (err) => { err.target.style.display = 'none'; };
                }}
              />
              <p className="text-muted">Devam etmek için hesabınıza giriş yapın.</p>
            </div>

            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label fw-bold text-secondary">E-posta Adresi</label>
                <input 
                  type="email" 
                  className="form-control form-control-lg" 
                  placeholder="ornek@saka.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label className="form-label fw-bold text-secondary">Şifre</label>
                <input 
                  type="password" 
                  className="form-control form-control-lg" 
                  placeholder="******"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-lg w-100 mb-3 shadow-sm">Oturum Aç</button>
            </form>
            
            <div className="text-center mt-5 text-muted small">
              &copy; {new Date().getFullYear()} AMC Fikir Sanat. Tüm hakları saklıdır.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
